<template>
  <v-container fluid>
    <v-row align="center">
      <v-col cols="12" md="auto">
        <BaseBreadcrumbs :crumbs="crumbs" class="px-0 py-0"/> 
      </v-col>
      <v-spacer/>
      <v-col cols="12" md="auto">
        <v-text-field
          v-model="input"
          filled
          dense
          flat
          solo
          clearable
          label="Tìm sản phẩm"
          placeholder="Vd: trái abc"
          prepend-inner-icon="mdi-magnify" 
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="search.rating"
          :items="rates"
          item-text="text"
          item-value="value"
          filled
          dense
          flat
          solo
          clearable
          label="Lọc theo thứ hạng"
          prepend-inner-icon="mdi-filter"
          hide-details
          multiple
          v-on:change="searchProduct"
        />
      </v-col>
      <v-col cols="12" sm="auto">
        <v-select
          v-model="sortSelected"
          :items="sorts"
          filled
          dense
          flat
          solo
          clearable
          label="Sắp xếp theo"
          prepend-inner-icon="mdi-sort-alphabetical-variant"
          hide-details
          v-on:change="searchProduct"
        />
      </v-col>
    </v-row>
    <h4 class="text-right mb-4 font-weight-light">
      Trang {{currentPage}} (Tổng {{totalPages}} Trang, {{totalItems}} mặt hàng)
    </h4>
    <h4 class="text-center mb-4 font-weight-light" v-if="!$store.state.loader && items.length==0">
      Không tìm thấy! Thử điều chỉnh lại các bộ lọc
    </h4>
    <v-row>
      <v-col 
        v-for="(product, index) in items" 
        :key="index" 
        cols="12"
        sm="6"
        md="3"
      >
        <v-sheet height="100%" class="rounded-lg overflow-hidden">
          <v-hover v-slot="{ hover }">
            <v-card flat class="ocop-product">
              <router-link
                :to="{ name: 'OcopProductTrace', params: { id: product.id }}"
              >
                <v-img
                  v-if="product.logoBase64"
                  height="170"
                  :src="product.logoBase64"
                  :style="{opacity: hover ? '0.3' : 1}"
                  class="img-transform"
                  :class="hover ? 'zoom' : ''"
                  contain
                />
                <v-img
                  v-else
                  height="170"
                  src="@/assets/ocop-logo.png"
                  :style="{opacity: hover ? '0.3' : 1}"
                  class="img-transform"
                  :class="hover ? 'zoom' : ''"
                  contain
                />
              </router-link>
              <v-card-title>
                <router-link
                  :to="{ name: 'OcopProductTrace', params: { id: product.id }}"
                  class="black--text text-body-2 font-weight-bold"
                >
                  {{product.tenSanPham}}
                </router-link>
                <v-spacer/>
                <span class="text-body-2 font-italic">
                  <v-icon small>mdi-eye</v-icon>
                  {{ product.countview || 1 }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-row
                  align="center"
                  class="mx-0"
                >
                  <v-rating
                    :value="product.xepHang"
                    color="amber"
                    background-color="grey lighten-1"
                    dense
                    half-increments
                    readonly
                    size="20"
                  />
                  <div class="grey--text ms-4">
                    {{ product.xepHang }} sao
                  </div>
                </v-row>
                <div class="mt-4 text-body-2">
                  <v-icon small>
                    mdi-map-marker
                  </v-icon>
                  {{product.diaChi}}
                </div>
              </v-card-text>
            </v-card>
          </v-hover>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="text-center">
          <v-pagination
            v-if="totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @input="handlePageChange"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import QrcodeVue from 'qrcode.vue';
  import { mapGetters, mapActions } from 'vuex';
  import BaseBreadcrumbs from '@/components/base/BaseBreadcrumbs';
  export default {
    components: {
      QrcodeVue,
      BaseBreadcrumbs
    },
    data: () => ({
      search: {
        keyword: '',
        rating: ''
      },
      loading: false,
      crumbs: [],
      crumbs: [],
      currentPage: 1,
      totalItems: 0,
      totalPages: 0,
      allItem: [],
      items: [],
      sorts: [
        {value: 'asc', text: 'A-Z'},
        {value: 'desc', text: 'Z-A'}
      ],
      sortSelected: null,
      rates: [
        { text: '1 Sao', value: 1}, 
        { text: '2 Sao', value: 2},
        { text: '3 Sao', value: 3},
        { text: '4 Sao', value: 4},
        { text: '5 Sao', value: 5}
      ],
      debouncedInput: '',
      timeout: null,
    }),
    mounted () {
      this.initialize();
      this.crumbs = [
        {
          text: 'Trang chủ',
          disabled: false,
          href: '/',
        },
        {
          text: 'Nhóm sản phẩm',
          disabled: false,
          href: '/products',
        },
        {
          text: 'Sản phẩm Ocop',
          disabled: true
        }
      ];
    },
    computed: {
      ...mapGetters([
        'isLogged'
      ]),
      input: {
        get() {
          return this.debouncedInput;
        },
        set(val) {
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.debouncedInput = val;
            this.initialize();
          }, 1000);
        }
      }
    },
    methods: {
      ...mapActions([
        'getLoader'
      ]),
      getRequestParams(page) {
        let params = {};

        if (page) {
          params["page"] = page;
        }

        if(this.search)
        {
          if(this.search.rating){
            params["rating"] = this.search.rating;
          }
          if(this.debouncedInput){
            params["keyword"] = this.debouncedInput;
          }
          if(this.sortSelected){
            params["sort"] = this.sortSelected;
          }
        }
        return params;
      },
      handlePageChange(value) {
        this.currentPage = value;
        this.initialize();
        this.$vuetify.goTo(0);
      },
      initialize () {
        const app = this;
        const params = app.getRequestParams(
          app.currentPage,
        );
        app.getLoader(true);
        let request = {
          params: params
        };
        axios.get("api/v1/public/get-ocop-products", request)
          .then(response => {
            app.items = response.data.data;
            app.totalItems = response.data.total;
            const caluTotalPage = response.data.total/response.data.per_page;
            app.totalPages = Math.ceil(caluTotalPage);
            app.getLoader(false);
          })
          .catch(function (error) {
            console.log(error);
            app.getLoader(false);
          });
      },
      GenerateURL(item){
        let path = this.$router.resolve({
          name: 'ProductTrace', 
          params: {
            id: item.id
          }
        });
        return `${window.location.origin}/${path.href}`;
      },
      searchProduct(){
        this.initialize();
      }
    }
  }
</script>
<style>
  .qrcode{
    border: 1px solid #79ce09;
    padding: 5px;
    cursor: zoom-in;
    position: absolute;
    right: 5px;
    top: 5px;
  }
  .v-card__actions.productInfo{
    text-overflow: ellipsis;
    height: 56px;
  }
  .v-image .v-image__image {
    transition: all 0.2s;
  }
  .v-image.zoom .v-image__image {
    transform: scale(1.2);
  }
  .v-card__text, .v-card__title {
    word-break: normal;
  }
</style>